import { useMutation, useQueryClient } from '@tanstack/react-query';

import api, { getErrorMessage } from '@/hooks/useApi';

// Types matching backend responses
export interface AdminGrantInput {
  userId: string;
  amount: number;
  reason: string;
}

export interface GrantResponse {
  transactionId: string;
  newBalance: number;
}

// Query keys for cache management
export const tokenKeys = {
  all: ['tokens'] as const,
  balance: (userId: string) => [...tokenKeys.all, 'balance', userId] as const,
};

/**
 * Grant tokens to a user (admin only)
 */
export function useAdminGrantTokens() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: AdminGrantInput) => {
      const response = await api.post<GrantResponse>('/tokens/grant', input);
      return response.data;
    },
    onSuccess: (_data, variables) => {
      // Invalidate any cached balance for this user
      queryClient.invalidateQueries({ queryKey: tokenKeys.balance(variables.userId) });
    },
    onError: (error) => {
      console.error('Admin grant tokens failed:', getErrorMessage(error));
    },
  });
}
